
/*
String body = "{\"operationName\":\"getAssetFolder\",\"variables\":{},\"query\":\"query getAssetFolder {  getAssetFolder(fullpath: \\\"/"+assetDir+"\\\") {    children { ... on asset {filename id  metadata {name data } } } }}\"}";

HttpRequest req = HttpRequest.newBuilder()
	.uri(new URI(
		baseUrl + "pimcore-graphql-webservices/orjan50?apikey=b342189a48309f9f6bb9b294ee652d7c"))

		*/

import JsonApi from "./Api/JsonApi";

export default class GraphQL {

	constructor() {
		this.jsonApi = new JsonApi();
	}

	query(name, variableDefinitions, variables, query, successFunction, errorFunction) {
		query = query.replaceAll("\n", ' ').replaceAll("\t", ' ')
		const request = {
			operationName: name,
			variables: variables,
			query: "query " + name + (variableDefinitions ? "("+variableDefinitions+")" : '') + " {"+query+"}"

		}

		this.jsonApi.post("/pimcore-graphql-webservices/orjan50", request, successFunction, errorFunction)
	}
}
